import * as Yup from 'yup'

export const mediaCreateSchema = Yup.object().shape({
  media: Yup.array().min(1, 'validation-required').required('validation-required'),
})
